"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _ReactHTMLPicture = _interopRequireDefault(require("@micado-digital/react-htmlpicture/ReactHTMLPicture"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Item = function Item(_ref) {
  var absoluteMediaURLs = _ref.absoluteMediaURLs,
      id = _ref.id,
      data = _ref.data,
      mediaFormats = _ref.mediaFormats,
      resourceURL = _ref.resourceURL,
      webpFallback = _ref.webpFallback,
      _onClick = _ref.onClick;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var media = null;

  if ((0, _isArray.default)(data === null || data === void 0 ? void 0 : data.media)) {
    var _data$media;

    media = data === null || data === void 0 ? void 0 : (_data$media = data.media) === null || _data$media === void 0 ? void 0 : _data$media[0];
  } else {
    media = data === null || data === void 0 ? void 0 : data.media;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick() {
      return _onClick(id);
    }
  }, /*#__PURE__*/_react.default.createElement(_ReactHTMLPicture.default, _extends({
    alt: data === null || data === void 0 ? void 0 : data.title,
    media: media,
    path: !absoluteMediaURLs ? resourceURL !== null && resourceURL !== void 0 ? resourceURL : REACT_APP_PATH : ""
  }, mediaFormats, {
    webpFallback: webpFallback
  })));
};

Item.propTypes = {
  absoluteMediaURLs: _propTypes.default.bool,
  id: _propTypes.default.number,
  data: _propTypes.default.object,
  mediaFormats: _propTypes.default.object,
  resourceURL: _propTypes.default.string,
  webpFallback: _propTypes.default.bool
};
var _default = Item;
exports.default = _default;